import { render, staticRenderFns } from "./c-form.vue?vue&type=template&id=a392bdb6&scoped=true"
import script from "./c-form.vue?vue&type=script&lang=js"
export * from "./c-form.vue?vue&type=script&lang=js"
import style0 from "./c-form.vue?vue&type=style&index=0&id=a392bdb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a392bdb6",
  null
  
)

export default component.exports